<template>
  <div class="ai-warp">
    <div class="header-warp">
      <header class="layoutMaxWidth">
        <h2>AI菜品识别计价机</h2>
        <p>突破技术，AI视觉 &nbsp;/&nbsp; 菜品识别自动计价机</p>
        <img src="@/assets/img/ai/ai.png" alt />
      </header>
    </div>

    <main>
      <title>AI菜品识别计价机</title>
      <ul class="layoutMaxWidth">
        <li>
          <img src="@/assets/img/ai/a1.png" alt />
          <h2>菜品识别，无需换餐盘</h2>
          <p>领先的AI视觉识别技术，视觉识别菜品，无需餐盘安装芯</p>
        </li>
        <li>
          <img src="@/assets/img/ai/a2.png" alt />
          <h2>精准识别，一秒计价</h2>
          <p>精准率可优于99.2%；识别和计价速度在1-2秒</p>
        </li>
        <li>
          <img src="@/assets/img/ai/a3.png" alt />
          <h2>性价比高</h2>
          <p>无需更改餐盘和动线，有效减少人力需求和人工错误</p>
        </li>
        <li>
          <img src="@/assets/img/ai/a4.png" alt />
          <h2>健康管理</h2>
          <p>采集每份消费订单的明细食材数据，为后续健康管理和运营管理提供大数据基础</p>
        </li>
      </ul>
    </main>
  </div>
</template>
<script>
export default {
  name: "ai",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.ai-warp {
  .header-warp {
    background: url("~@/assets/img/ai/bg1@2x.png") center center no-repeat;
    box-sizing: 100% 100%;
    height: 385px;
  }
  header {
    display: block;
    font-style: italic;
    position: relative;
    h2 {
      padding-top: 159px;
      font-size: 54px;
      padding-bottom: 34px;
      font-weight: 700;
    }
    p {
      letter-spacing: 4px;
      font-size: 20px /*px*/;
      font-weight: 700;
    }
    img {
      position: absolute;
      top: 72px;
      right: 0;
      width: 202px;
    }
  }
  main {
    background: url("~@/assets/img/ai/bg@2x.png") top left no-repeat;
    background-size: 100% 100%;
    // width: 100%;
    height: 756px;
    title {
      display: inline-block;
      width: 100%;
      font-size: 21px /*px*/;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: white;
      padding-top: 89px;
    }
    title::after,
    title::before {
      display: inline-block;
      content: "";
      width: 64px;
      height: 1px;
      background-color: #9c9fa1;
      vertical-align: middle;
      margin-right: 16px;
    }
    title::after {
      margin-right: 0px;
      margin-left: 16px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 61px;
      li {
        background-color: white;
        padding: 49px 38px 0;
        margin-right: 17px;
        margin-top: 2%;
        width: 48.95%;
        height: 229px;
        box-sizing: border-box;
        img {
          width: 44px;
        }
        h2 {
          font-size: 16px;
          color: $primary-color;
          margin-top: 30px;
        }
        p {
          margin-top: 4px;
          font-size: 11px;
          line-height: 1.5em;
        }
      }
      li:nth-child(2n) {
        margin-right: 0px;
      }
      li:last-child{
        h2{
          margin-top: 25px;
        }
        img{
          width: 46px;
        }
      }
      li:nth-of-type(2){
        h2{
          margin-top: 25px;
        }
        img{
          width: 52px;
        }
      }
    }
  }
}
</style>